import * as ReactIntl from 'react-intl';
window.ReactIntl = ReactIntl;

export default {};
